import { Component, OnInit } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Observable, startWith, Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { ConfirmDialogComponent, DEFAULT_SNACKBAR_CONFIG, Logger } from 'src/app/@shared';
import { AuthorizationService } from 'src/app/@shared/services/authorization.service';
import { Sort } from '@angular/material/sort';
import { AssetDomain, AssetsDomainService, User, UserDomain, UserService } from '../..';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

const log = new Logger('SettingsComponent');

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})

export class SettingsComponent implements OnInit {

  isPurgingImageCache = false;

  constructor(
    private matSnackBar: MatSnackBar,
    private assetDomainService: AssetsDomainService<AssetDomain>,
    private dialog: MatDialog,
    private authorizationService: AuthorizationService
  ) { }

  ngOnInit(): void {}

  generateSearchIndex() {
    this.assetDomainService.generateSearchIndex().subscribe(res => {
      this.matSnackBar.open(`Generated assets search index`, 'OK', DEFAULT_SNACKBAR_CONFIG);
    })
  }

  get isAdmin(): boolean {
    return this.authorizationService.checkAccess('admin||navbar');
  }

  purgeImageCache() {
    if (this.isPurgingImageCache) {
      return;
    }

    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Purge Image Cache',
        message: 'This will clear all cached images for the organization. Are you sure you want to continue?',
        confirmText: 'Yes',
      },
      disableClose: true,
    });

    confirmDialog.afterClosed().subscribe(confirmResult => {
      if (!confirmResult) {
        return;
      }

      this.isPurgingImageCache = true;

      this.assetDomainService.purgeImageCache().subscribe({
        next: () => {
          this.isPurgingImageCache = false;
          this.matSnackBar.open('Image cache purged successfully', 'OK', DEFAULT_SNACKBAR_CONFIG);
        },
        error: (error) => {
          this.isPurgingImageCache = false;
          log.error('Error purging image cache', error);

          const message = error?.error?.message || error?.error?.value || 'Failed to purge the image cache. Please try again.';
          const errorConfig = { ...DEFAULT_SNACKBAR_CONFIG };
          delete errorConfig.duration;
          this.matSnackBar.open(message, 'OK', errorConfig);
        }
      });
    });
  }

}
